'use client';
import { useEffect } from 'react';

const PixelAudienceObservability = () => {
	useEffect(() => {
		const script = document.createElement('script');
		script.innerHTML = `!function(a,e,d,m,t){
      a.adm={}; a.adm.pixid=154764;
      var o=e.getElementsByTagName("head")[0], c=e.createElement("script");
      a.adm.json="https://ps.l.liftdsp.com/547bb86a-0c5b-4b9f-b2fd-b3b23c49a9fe.json";
      a.adm.pixurl="https://pool.admedo.com";
      c.src="https://pj.l.liftdsp.com/admtracker.lib.min.js";
      c.async=!0; o.appendChild(c);
    }(window,document);`;
		document.head.appendChild(script);

		return () => {
			document.head.removeChild(script);
		};
	}, []);

	return (
		<noscript>
			<img
				height="1"
				width="1"
				style={{ display: 'none' }}
				src="https://pool.admedo.com/pixel?id=154764&t=img"
				alt=""
			/>
		</noscript>
	);
};

export default PixelAudienceObservability;
